import { Model, Factory, belongsTo } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import type { SchemaAttributes } from '../../types.js'
import {
  rand,
  randNumber,
  randFirstName,
  randLastName,
  randPhoneNumber,
} from '@ngneat/falso'

import type { MockServer } from '../server.js'
import { getTodayDateTimeISO } from '@/utils/date/getter.js'
import { CONSTANTS } from './constants.js'
import { getInitials } from '@/utils/string.js'

export type ConversationParticipant =
  SchemaAttributes<'ConversationParticipant'>

export const model = (Model as ModelDefinition<ConversationParticipant>).extend(
  {
    conversation: belongsTo('conversation'),
  },
)

export const factory = Factory.extend<ConversationParticipant>({
  participant_type() {
    return rand([...CONSTANTS.participant.types])
  },
  participant_internal_id() {
    return randNumber(CONSTANTS.participant.internalIdRange)
  },
  created_at() {
    return getTodayDateTimeISO()
  },
  updated_at() {
    return getTodayDateTimeISO()
  },
  info() {
    const firstName = randFirstName()
    const lastName = randLastName()
    const initials = getInitials([firstName, lastName])
    return {
      first_name: firstName,
      last_name: lastName,
      initials,
      phone_number: randPhoneNumber({
        countryCode: CONSTANTS.participant.defaultCountryCode,
      }),
      avatar: '',
    }
  },
})

export function routes(_server: MockServer) {
  // No specific routes needed for participants
  // They are accessed through the conversation include
}

export function seeds(_server: MockServer) {
  // Participants are created with conversations
}
